export default __webpack_public_path__ + "static/char-s-07-jp-975dc2fbb37dd00b5376c20a397ab646.png";